import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseuri from '../../baseuri';
import { randomgen } from '../../utils/general-utils';
import { addToLoadingQueue, removeFromLoadingQueue } from './general';

export const getWithdrawalRequests = createAsyncThunk(
	'withdrawal-requests/getWithdrawalRequests',
	async (params: any, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		const res = await baseuri.get('/admin/wallet/withdrawal-requests', {
			params: { ...params, sort: 'desc' },
		});
		dispatch(removeFromLoadingQueue(loadingId));
		return res.data.data;
	}
);

export const getWithdrawalRequestsPayoutStatus = createAsyncThunk(
	'withdrawal-requests/getWithdrawalRequestsPayoutStatus',
	async (requestId: any, { dispatch }) => {
		console.log('requestId', requestId);
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		const res = await baseuri.get(
			`/admin/wallet/withdrawal-requests/${requestId}`
		);
		dispatch(removeFromLoadingQueue(loadingId));
		return res.data.data;
	}
);

export const getWithdrawalRequestCount = createAsyncThunk(
	'withdrawal-requests/getWithdrawalRequestCount',
	async (params: any, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		const res = await baseuri.get('/admin/wallet/withdrawal-requests-count', {
			params,
		});
		dispatch(removeFromLoadingQueue(loadingId));
		return res.data.data;
	}
);

const withdrawaRequestRx = createSlice({
	name: 'withdrawal-requests',
	initialState: {
		itemsList: [],
		paginator: {
			itemCount: 0,
			currentPage: 1,
			perPage: 10,
		},
		withdrawalRequestCount: {
			cancelled: 0,
			deleted: 0,
			success: 0,
			review: 0,
			retry: 0,
			failed: 0,
			pending: 0,
			processing: 0,
			hold: 0,
			refunded: 0,
		},
		withdrawalRequestsPayoutStatus: {
			_id: '',
			userId: {
				_id: '',
				email: '',
				createdAt: '',
				referralLink: '',
				username: '',
				fullName: '',
				phoneNo: '',
			},
			destinationAddress: null,
			fiatPaymentAccountDetails: null,
			destinationPaymentDetailId: {
				_id: '',
				userId: '',
				paymentMethod: '',
				paymentType: '',
				commercialBankId: '',
				bankName: '',
				accountName: '',
				accountNumber: '',
				sortCode: '',
				comments: '',
				removed: false,
				createdAt: '',
				updatedAt: '',
			},
			commercialBankId: {
				_id: '',
				name: '',
				symbol: '',
				sortCode: '',
				institutionType: '',
				nibssCode: '',
				institutionCode: '',
				category: '',
				institutionId: '',
				address: '',
				bankLogoUrl: '',
				localCurrencyId: '',
				countryCode: '',
				status: '',
				createdAt: '',
				updatedAt: '',
				__v: 0,
			},
			amount: 0,
			finalAmount: 0,
			fee: '0',
			feeInUsd: 0,
			discount: '0',
			discountApplied: false,
			currencyId: {
				_id: '',
				name: '',
				symbol: '',
				switchWalletId: '',
				decimalPrecision: 0,
				minimumWithdrawalAmount: 0,
				currencyForm: '',
				lastUpdatedBy: '',
				iconUrl: '',
				iconEncryptKey: null,
				coinGeckoId: '',
				allowWithdrawal: true,
				allowSavings: false,
				allowStaking: true,
				allowSwapping: true,
				allowLoans: false,
				stakingApyPercentage: 0,
				currentXendBridgeSellRate: 0,
				currentXendBridgeBuyRate: 0,
				usdValue: 0,
				status: '',
				allowFlexibleAutoSave: true,
				allowFixedAutoSave: true,
				useInvestment: false,
				createdAt: '',
				updatedAt: '',
				__v: 0,
				pricePriority: false,
				useXendBridge: false,
				allowedSwapPairs: [],
				allowDeposit: true,
			},
			blockchainMemo: null,
			withdrawalAddressWhiteListId: null,
			status: 0,
			paymentGatewayId: {
				_id: '',
				name: '',
				gateWayKey: '',
				singlePayOutLimit: 0,
				singleDepositLimit: 0,
				depositFeePercentage: 0,
				depositFeeCapAmount: 0,
				cashoutFeeFixedAmount: 0,
				chargeDepositFee: true,
				chargePayOutFee: true,
				depositFeeFlatAmount: 0,
				payoutFeeFlatAmount: 0,
				payoutFeePercentage: 0,
				payoutFeeCapAmount: 0,
				isDefault: false,
				allowDeposit: false,
				allowWithdrawal: true,
				priority: 0,
				localCurrencyId: '',
				status: '',
				createdAt: '',
				updatedAt: '',
				__v: 0,
				allowVirtualDeposit: false,
			},
			holdReason: null,
			usdValue: 0,
			cryptoBalanceId: {
				_id: '',
				userId: '',
				balance: 0,
				userEmail: '',
				currencyId: '',
				autoSaveReInvestFixed: false,
				autoSaveFlexible: false,
				autoSaveFixed: false,
				autoSaveFormatAllFunds: true,
				autoSavDurationDays: 0,
				autoStake: false,
				createdAt: '',
				updatedAt: '',
			},
			initiator: 0,
			nativeTokenPrice: 0,
			gasPriceInUsd: 0,
			gasPriceInNativeToken: 0,
			formerBalance: '0',
			processingChannel: 0,
			inAppTransaction: false,
			gasFeeUpdate: '',
			withdrawalType: '',
			sellTax: 0,
			revertedByAdminId: null,
			createdAt: '',
			updatedAt: '',
			__v: 0,
			transactionHash: '',
			paymentGatewayPayoutStatus: {
				supported: true,
				providerKey: '',
				completed: true,
				pending: false,
				sessionId: '',
				message: '',
				raw: {
					statusCode: 0,
					responseCode: '0',
					message: '',
					data: {
						queued: false,
						limitExceeded: false,
						_id: '',
						client: '',
						account: '',
						type: '',
						sessionId: '',
						nameEnquiryReference: '',
						paymentReference: '',
						mandateReference: null,
						isReversed: false,
						reversalReference: null,
						provider: '',
						providerChannel: '',
						providerChannelCode: '',
						destinationInstitutionCode: '',
						creditAccountName: '',
						creditAccountNumber: '',
						creditBankVerificationNumber: null,
						creditKYCLevel: '',
						debitAccountName: '',
						debitAccountNumber: '',
						debitBankVerificationNumber: null,
						debitKYCLevel: '0',
						transactionLocation: '0',
						narration: '',
						amount: 0,
						fees: 0,
						vat: 0,
						stampDuty: 0,
						responseCode: '0',
						responseMessage: '',
						status: '',
						isDeleted: false,
						createdAt: '',
						createdBy: '',
						updatedAt: '',
					},
				},
			},
		},
	},
	reducers: {
		updateWithdrawalStatus: (state, action) => {
			const store = state;
			const { requestId, status } = action.payload;
			const updatedList: any = store.itemsList.map((request: any) => {
				if (request._id === requestId) {
					return { ...request, status };
				}
				return request;
			});
			store.itemsList = updatedList;
		},
	},
	extraReducers: (builder) =>
		builder
			.addCase(getWithdrawalRequests.fulfilled, (store, action) => {
				let state = store;
				state = { ...state, ...action.payload };
				return state;
			})
			.addCase(getWithdrawalRequestsPayoutStatus.fulfilled, (store, action) => {
				const state = store;
				state.withdrawalRequestsPayoutStatus = action.payload;
			})
			.addCase(getWithdrawalRequestCount.fulfilled, (store, action) => {
				const state = store;
				state.withdrawalRequestCount = action.payload;
			}),
});

export const { updateWithdrawalStatus } = withdrawaRequestRx.actions;

export default withdrawaRequestRx.reducer;
